import React from "react";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { SITE_URL } from "gatsby-env-variables";

import { useAlert } from "../../context/AlertContext";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import { COLORS } from "../../utils/colors";

import { Button, InputField } from "../../components";
import TextareaField from "../textarea/TextareaField";

const LetsTalk = () => {
  const { isSmallScreen, isTablet } = useWindowDimensions();
  const { setAlert } = useAlert();

  type ContactFormValues = {
    firstName: string;
    lastName: string;
    email: string;
    message: string;
  };

  const initialValues: ContactFormValues = {
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  };

  const requiredMessage = "This field is required.";

  const validation = Yup.object({
    firstName: Yup.string().required(requiredMessage),
    lastName: Yup.string().required(requiredMessage),
    email: Yup.string().email().required(requiredMessage),
    message: Yup.string().required(requiredMessage),
  });

  const handleSubmit = async (
    formData: ContactFormValues,
    { resetForm }: FormikHelpers<ContactFormValues>
  ) => {
    try {
      await axios({
        method: "post",
        url: `${SITE_URL}/send_email.php`,
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: formData,
      });

      setAlert({ message: "Your email has been sent successfully.", type: "success" });
      resetForm();
    } catch (error) {
      setAlert({ message: "Error", type: "error" });
    }
  };

  return (
    <div
      className={`m-contact__left column ${isSmallScreen ? "fullWidth" : ""}`}
    >
      <h1>Let's talk</h1>
      <div className=" column">
        <Formik
          onSubmit={handleSubmit}
          validationSchema={validation}
          initialValues={initialValues}
        >
          {({ handleSubmit }) => (
            <Form>
              <div className="column -row-gap20">
                <div
                  className={`fullWidth ${
                    isTablet
                      ? "column -row-gap20"
                      : "aligned-start -column-gap10"
                  }`}
                >
                  <InputField
                    name="firstName"
                    label="First name"
                    placeholder="Enter your first name"
                    dark={true}
                    required
                  />
                  <InputField
                    name="lastName"
                    label="Last name"
                    placeholder="Enter your last name"
                    dark={true}
                    required
                  />
                </div>
                <InputField
                  label="Email"
                  name="email"
                  placeholder="Enter your email"
                  dark={true}
                  required
                />
                <TextareaField
                  label="Message"
                  name="message"
                  placeholder="Enter your message here"
                  required
                />
                <Button
                  name="Send message"
                  handleClick={handleSubmit}
                  buttonClass="secondary"
                  icon
                  iconColor={COLORS.white}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LetsTalk;
